import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#F69100",
  d: "M6 33.5h2.039a2 2 0 0 0 1.561-.75l7.206-9.007q.194-.242.452-.415L20 21.5m-11.5 22h7.712a2 2 0 0 0 1.364-.538l12.502-11.669a2.714 2.714 0 0 0-3.618-4.045L23 30.214M21.5 31.5l1.5-1.286m0 0v-5.012a2 2 0 0 0-.438-1.25l-5.124-6.404a2 2 0 0 1-.438-1.25v-1.97a2 2 0 0 1 .586-1.414L21 9.5m0 5V7a2.5 2.5 0 0 1 5 0v1-.75a2.25 2.25 0 0 1 4.5 0V9v-.25a2.25 2.25 0 0 1 4.5 0V11v-.25a2.25 2.25 0 0 1 2.25-2.25 2.25 2.25 0 0 1 2.25 2.247V20c0 3-3 3.5-3 5.5V38"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#F69100",
  d: "M33.938 27.551a6 6 0 0 1-5.508 7.651M25.673 24.014a5.98 5.98 0 0 1 5.756.212"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }